<template>
  <div class="tabs-bar" ref="tabsBar">
    <div class="actions">
      <span :class="{ disabled: isFirst }" @click="handlePrev">
        <i class="el-icon-back" />
      </span>
      <span :class="{ disabled: isLast }" @click="handleNext">
        <i class="el-icon-right" />
      </span>
      <span @click="onRefresh">
        <i class="el-icon-refresh-right" />
      </span>
    </div>
    <ul ref="tabs" class="tabs" :style="tabsStyle">
      <li
        class="tab"
        :class="{ 'is-act': route.path === history.path }"
        v-for="(history, idx) in histories"
        :key="idx"
        @click="handlePush(history)"
      >
        <span
          class="name"
          v-text="
            `${parseTitle(history.title)}${
              history.subTitle ? ` - ${history.subTitle}` : ''
            }`
          "
        ></span>
        <span
          class="remove"
          v-if="histories.length > 1"
          @click.stop="handleClose(idx, history)"
        >
          <i class="el-icon-close" />
        </span>
      </li>
    </ul>
    <div class="tab-more" v-if="showDropdown">
      <i class="el-icon-more"></i>
      <el-select :value="currentIndex" @change="onSelectChange">
        <el-option
          v-for="(history, i) in histories"
          :key="i"
          :label="`${parseTitle(history.title)}${
            history.subTitle ? ` - ${history.subTitle}` : ''
          }`"
          :value="i"
        >
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
import {
  addResizeListener,
  removeResizeListener,
} from "element-ui/src/utils/resize-event";
import { parseTitle } from "../../utils/tab-title";
export default {
  name: "TabsBar",
  data() {
    return {
      tabsWidth: "100%",
      histories: [],
      showDropdown: false,
    };
  },
  computed: {
    route() {
      return this.$route;
    },
    exclude() {
      return this.$store.state.exclude;
    },
    path() {
      return this.$route.path;
    },
    currentIndex() {
      return this.findIndex(this.path);
    },
    isFirst() {
      return this.currentIndex === 0;
    },
    isLast() {
      return this.currentIndex === this.histories.length - 1;
    },
    tabsStyle() {
      let flag = this.tabsWidth.indexOf("%") != -1;
      return {
        width: flag ? flag : `${this.tabsWidth}px`,
      };
    },
  },
  watch: {
    $route(to) {
      this.storeToHistory(to);
    },
    currentIndex() {
      this.renderTabs();
    },
  },
  created() {
    if (this.route.path !== "/") {
      this.storeToHistory(this.route);
    }
    this.registerEvents();
  },
  mounted() {
    this.$nextTick(() => {
      this.tabsWidth = `${this.$refs.tabsBar.offsetWidth - 160}`;
      this.renderTabs();
    });
    addResizeListener(this.$el, this.onResize);
  },
  beforeDestroy() {
    removeResizeListener(this.$el, this.onResize);
    this.bus.$off("closeTab", this.handleCloseTab);
    this.bus.$off("setTabTitle", this.handleSetTabTitle);
  },
  methods: {
    onResize() {
      this.tabsWidth = `${this.$refs.tabsBar.offsetWidth - 160}`;
      this.renderTabs();
    },
    parseTitle,
    registerEvents() {
      this.bus.$on("closeTab", this.handleCloseTab);
      this.bus.$on("setTabTitle", this.handleSetTabTitle);
    },
    handleCloseTab(path) {
      let index = this.findHistoryIndex(path);
      if (index >= 0) {
        let history = this.histories[index];
        this.handleClose(index, history);
      }
    },
    handleSetTabTitle({ path, title }) {
      console.log("handleSetTabTitle", path, title);
      let index = this.findHistoryIndex(path);
      if (index >= 0) {
        this.$set(this.histories[index], "subTitle", title);
      }
    },
    renderTabs() {
      this.$nextTick(() => {
        const tabs = this.$refs.tabs;
        let childrenWidthTotal = 0;
        const children = Array.prototype.slice.call(tabs.children);
        children.forEach((child) => {
          const childWidth = child.offsetWidth + 5;
          childrenWidthTotal += childWidth;
        });
        this.showDropdown = childrenWidthTotal - parseInt(this.tabsWidth) > 10;
        let activeChild = tabs.children[this.currentIndex];
        tabs.scrollLeft = activeChild.offsetLeft;
      });
    },
    findHistoryIndex(path) {
      return this.histories.findIndex((i) => i.path === path);
    },
    onRefresh() {
      this.bus.$emit("refresh", {
        name: this.route.meta.title,
      });
    },
    handlePrev() {
      if (!this.isFirst) {
        this.handlePush(this.histories[this.currentIndex - 1]);
      }
    },
    handleNext() {
      if (!this.isLast) {
        this.handlePush(this.histories[this.currentIndex + 1]);
      }
    },
    findIndex(path) {
      return this.histories.findIndex((x) => x.path === path);
    },
    storeToHistory(to) {
      let path = to.path;
      let route = {
        path: path,
        fullPath: to.fullPath,
        name: to.meta.key || to.meta.title,
        title: to.meta.title,
      };
      if (to.name !== "authorise" && !this.isExist(route)) {
        let idx = this.exclude.findIndex((name) => name === route.name);
        if (idx !== -1) {
          let _exclude = [].concat(this.exclude);
          _exclude.splice(idx, 1);
          this.$store.commit("updateState", {
            exclude: _exclude,
          });
        }
        this.histories.push(route);
      } else {
        const index = this.findHistoryIndex(path);
        if (index !== -1) {
          const _route = this.histories[index];
          if (_route.fullPath !== to.fullPath) {
            this.$set(this.histories[index], "fullPath", to.fullPath);
          }
        }
      }
    },
    isExist(route) {
      return this.histories.some((x) => x.path === route.path);
    },
    onSelectChange(index) {
      this.handlePush(this.histories[index]);
    },
    handlePush(history) {
      this.$router.push(history.fullPath);
    },
    handleClose(idx, history) {
      if (idx === 0) {
        let next = this.histories[idx + 1];
        this.handlePush(next);
      } else {
        let prev = this.histories[idx - 1];
        this.handlePush(prev);
      }
      this.histories.splice(idx, 1);
      if (!this.exclude.some((name) => name === history.name)) {
        let exclude = this.exclude.concat([history.name]);
        this.$store.commit("updateState", {
          exclude: exclude,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.tabs-bar {
  height: 100%;
  display: flex;
  align-items: flex-end;
  .actions {
    padding: 0 10px;
    display: flex;
    height: 40px;
    display: flex;
    align-items: center;
    span {
      display: inline-block;
      padding: 5px;
      line-height: 22px;
      text-align: center;
      width: 30px;
      height: 30px;
      border-radius: 100%;
      cursor: pointer;
      font-size: 16px;
      color: #5f6368;
      i {
        font-weight: bold;
      }
      &:not(.disabled):hover {
        background-color: #fff;
      }
      &.disabled {
        color: #babcbe;
        pointer-events: none;
      }
    }
    .el-icon-refresh-right {
      color: $theme-color;
    }
  }
  .tabs {
    display: flex;
    align-items: flex-end;
    flex: 1;
    height: 50px;
    overflow: hidden;
    position: relative;
    .tab {
      position: relative;
      &.is-act {
        border-top: 2px solid $theme-color;
        font-weight: bold;
        color: #000;
      }
      background-color: #ffffff;
      white-space: nowrap;
      cursor: pointer;
      line-height: 40px;
      padding: 0 10px;
      margin-right: 5px;
      transition: background-color 0.2s;
      .remove {
        margin-left: 5px;
        font-weight: bold;
        cursor: pointer;
        &:hover {
          color: $theme-color;
        }
      }
    }
  }
  .tab-more {
    background-color: #ffffff;
    white-space: nowrap;
    cursor: pointer;
    color: #5f6368;
    line-height: 40px;
    padding: 0 10px;
    margin: 0 5px;
    position: relative;
    .el-select {
      position: absolute;
      left: 0;
      top: 0;
      width: 30px;
      overflow: hidden;
      opacity: 0;
    }
  }
}
</style>
